import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga4';
import { Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';

function NavDropdown(props) {

    const [open, setOpen] = useState(false);
    const [menuPos, setMenuPos] = useState({ top: 0, left: 0 });
    const toggleRef = useRef(null);
    const ref = useRef(null);

    const handleClick = (e) => {
        e.preventDefault();
        if (!open && toggleRef.current) {
            const rect = toggleRef.current.getBoundingClientRect();
            setMenuPos({ top: rect.bottom + window.scrollY, left: rect.left + window.scrollX });
        }
        setOpen(prev => !prev);
        ReactGA.event({
            category: 'Navigation',
            action: 'Clicked DropDown',
            label: 'Selected ' + props.children + ' from ' + props.name,
        });
    }

    useEffect(() => {
        const handleOutsideClick = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleOutsideClick);
        return () => document.removeEventListener('mousedown', handleOutsideClick);
    }, []);

    let isActive = '';
    const pageURI = window.location.pathname + window.location.search;
    var paths = pageURI.split('/');
    for (let nav of props.nav) {
        if (nav.path && paths.indexOf(nav.path.replace('/', '')) !== -1) {
            isActive = 'active';
            break;
        }
    }

    // Check if this is the user menu dropdown (contains UserIcon)
    const isUserMenu = props.name && props.name.type && props.name.type.name === 'UserIcon';

    if (isUserMenu) {
        // Convert children to Ant Design menu items
        const menuItems = React.Children.map(props.children, (child, index) => {
            if (!child) return null;
            return {
                key: child.props.id || index,
                label: child.props.name,
                onClick: () => {
                    if (child.props.path) {
                        window.location.href = child.props.path;
                    }
                }
            };
        }).filter(Boolean);

        return (
            <li className={`nav-item dropdown ${isActive}`}>
                <Dropdown
                    menu={{ items: menuItems }}
                    trigger={['hover']}
                    placement="bottomRight"
                >
                    <a className="nav-link" onClick={(e) => e.preventDefault()} href="/" style={{ cursor: 'pointer' }}>
                        {props.name} <DownOutlined style={{ fontSize: '10px', marginLeft: '4px' }} />
                    </a>
                </Dropdown>
            </li>
        );
    }

    // Original dropdown behavior for non-user menus
    const dropdownMenu = open ? ReactDOM.createPortal(
        <div
            ref={ref}
            className="dropdown-menu border-rounded show"
            style={{ position: 'absolute', top: menuPos.top, left: menuPos.left, zIndex: 1050 }}
            aria-labelledby="navbarDropdown"
            onMouseDown={e => e.stopPropagation()}
        >
            {props.children}
        </div>,
        document.body
    ) : null;

    return (
        <li className={`nav-item dropdown ${isActive}${open ? ' show' : ''}`}>
            <a ref={toggleRef} className="nav-link dropdown-toggle" onClick={handleClick} href="/" id="navbarDropdown" role="button"
                aria-haspopup="true" aria-expanded={open}>
                {props.name}
            </a>
            {dropdownMenu}
        </li>
    )
}

export default NavDropdown;